import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { QueryClientProvider } from "@tanstack/react-query";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { router } from "./routes";
import { useEffect } from "react";
import { scrollToTopInstant } from "./utils/scrollToTop";
import { CartProvider } from "./context/cartContext";
import { queryClient } from "./services/queryClient";

function App() {
  useEffect(() => {
    const handleRouteChange = () => {
      scrollToTopInstant();
    };
    window.addEventListener("popstate", handleRouteChange);
    return () => window.removeEventListener("popstate", handleRouteChange);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <CartProvider>
        <RouterProvider router={router} />
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          className="toast-container-custom"
          toastClassName="toast-custom"
          progressClassName="toast-progress-custom"
        />
      </CartProvider>
    </QueryClientProvider> 
  );
}

export default App;
